const trim = (value) => String(value || "").replace(/\/+$/, "");
const pickConfigured = (...values) =>
  values.find((value) => String(value || "").trim().length > 0);

const host = window.location.hostname;
const protocol = window.location.protocol;

const isPrivate =
  /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[0-1])\.)/.test(host);
const isLocal = host === "localhost" || host === "127.0.0.1" || isPrivate;

const localPublicBaseUrl = `${protocol}//${host}:50000`;
const localApiBaseUrl = `${protocol}//${host}:50003`;
const localWsBaseUrl = localApiBaseUrl
  .replace(/^http/i, "ws")
  .replace(/:50003$/, ":1825");

const defaultPublicBaseUrl = isLocal
  ? localPublicBaseUrl
  : "https://salew-bot.ru";
const defaultApiBaseUrl = isLocal
  ? localApiBaseUrl
  : "https://pandoras-box.salew-bot.ru";
const defaultWsBaseUrl = isLocal
  ? localWsBaseUrl
  : "wss://pandoras-box.salew-bot.ru";

const envPublicBaseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const envWsBaseUrl = process.env.REACT_APP_WS_BASE_URL;

export const PUBLIC_BASE_URL = trim(
  pickConfigured(envPublicBaseUrl, defaultPublicBaseUrl)
);
export const API_BASE_URL = trim(pickConfigured(envApiBaseUrl, defaultApiBaseUrl));

const wsFromConfiguredApi = envApiBaseUrl
  ? API_BASE_URL.replace(/^http/i, "ws")
  : "";
export const WS_BASE_URL = trim(
  pickConfigured(envWsBaseUrl, wsFromConfiguredApi, defaultWsBaseUrl)
);

if (process.env.NODE_ENV !== "production") {
  console.info("[runtime]", {
    host,
    isLocal,
    API_BASE_URL,
    WS_BASE_URL,
    PUBLIC_BASE_URL,
  });
}
